import { render, staticRenderFns } from "./BillDetailsView.vue?vue&type=template&id=283b558a&scoped=true&"
import script from "./BillDetailsView.vue?vue&type=script&lang=js&"
export * from "./BillDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./BillDetailsView.vue?vue&type=style&index=0&id=283b558a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b558a",
  null
  
)

export default component.exports